var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es248.js.map
